// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--2P8nlFm","mask":"mask--1Z5zMRa"};